import { useQuery } from "@tanstack/react-query";
import { useContext } from "react";
import { Calendar } from "lucide-react";
import { AuthContext } from "../../../contexts/AuthContext";
import { handleCountBookings } from "../../../apis/bookings";

export default function FulfilledWidget() {
  const { site } = useContext(AuthContext);

  const { data: count } = useQuery({
    queryKey: ["fulfilledCount", site?._id],
    queryFn: () =>
      handleCountBookings({
        site: site?._id === 0 ? "" : site?._id,
        isConfirmed: 1,
        isFulfilled: 1,
      }),
  });

  return (
    <div className="col-span-12 sm:col-span-6 md:col-span-3 border border-gray-200 rounded-md shadow-md p-2 bg-violet-500 text-white">
      <div className="flex">
        <div className="flex justify-center items-center w-14 h-14 bg-violet-400 border border-violet-400">
          <Calendar size={34} />
        </div>
        <div className="flex flex-col border-l border-violet-300 pl-2 ml-2">
          <div className="uppercase">Handled Bookings</div>
          <div className="font-bold text-2xl">{count}</div>
        </div>
      </div>
    </div>
  );
}
